import Link from "next/link";

const NotFoundSection = () => {
  return (
    <div className="w-full bg-white py-20 px-6">
      <div className="max-w-5xl mx-auto text-center">
        {/* Heading */}
        <h1 className="text-[50px] font-[HelveticaRoman, Helvetica, sans-serif] text-[#232323] font-[500] leading-[1.1] mb-[70px]">
          Oops! We couldn&apos;t find this page for you.
        </h1>

        {/* Content Box */}
        <div className="text-left">
          <h2 className="text-[18px] text-[#232323] font-[HelveticaRoman, Helvetica, sans-serif] text-[#232323] font-[500] leading-[1.1] mb-[10px]">
            Possible reasons for this error:
          </h2>

          <ul className="list-disc pl-6 font-[HelveticaRoman, Helvetica, sans-serif] text-[#232323] text-sm md:text-base">
            <li>
              A mistyped URL.{" "}
              <span className="">(check the URL to see it is correct)</span>
            </li>
            <li>
              A broken link from another site{" "}
              <span className="">
                (if you clicked on a broken link from another site, please click{" "}
                <Link href="/" className="text-blue-600 hover:no-underline">
                  Home
                </Link>{" "}
                link)
              </span>
            </li>
            <li>
              A broken link from this site{" "}
              <span className="">
                (please{" "}
                <Link
                  href="/contact-us"
                  className="text-blue-600 hover:no-underline"
                >
                  Contact
                </Link>{" "}
                us)
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NotFoundSection;
